import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { isNotEmptyArray, renderWithLinks } from 'utils';

import ExamplesCard from './ExamplesCard';
import { CardList, CardSlider } from '../widgets/DataRenderer';
import LinkBack from '../widgets/LinkBack';
import Spinner from '../widgets/Spinner';

import './examples.scss';

class ExamplesTemplate extends PureComponent {
  render() {
    const { isMobile, examples } = this.props;

    const items = examples.results.map(item => {
      const props = Object.assign({}, item, {
        buttonLabel: this.props.buttonLabel,
        previewText: renderWithLinks(item.previewText)
      });

      return <ExamplesCard {...props} />;
    });

    const ListComponent = isMobile ? CardList : CardSlider;

    return (
      <div className="examples">
        <Helmet>
          <title>Примеры</title>
        </Helmet>

        <div className="examples-content">
          <div className="container">
            <LinkBack link="/promotion/subnavigation/">
              продвигаем <i>вернуться</i>
            </LinkBack>

            <h1 className="examples-title">
              Примеры
            </h1>
          </div>

          <div className="data-renderer-container">
            <div className="container">
              {(isNotEmptyArray(items)) &&
                <ListComponent items={items} />
              }

              {(!isNotEmptyArray(examples.results) && examples.isFetching) &&
                <div className="examples-spinner">
                  <Spinner />
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ExamplesTemplate.propTypes = {
  examples: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object),
    isFetching: PropTypes.bool,
    fetchingErrors: PropTypes.object
  }),
  buttonLabel: PropTypes.string,
  isMobile: PropTypes.bool
};

export default ExamplesTemplate;



// WEBPACK FOOTER //
// ./src/components/Examples/ExamplesTemplate.js